import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/Privilege`
//#region Menu相关
const GetList = `${apiUrl}`
const Get = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Put = (id: number) => `${apiUrl}/${id}`
const Post = `${apiUrl}`
const GetParentList = `${apiUrl}/parentList`
const GetCategoryList = `${apiUrl}/categoryList`
//#endregion

export const emptyPrivilege: PrivilegeData = {
    ItemId: 0,
    ItemCode: '',
    ParentId: 0,
    ItemName: '',
    ItemUrl: '',
    SeqId: 0,
    IsMenu: true,
    Icon: 'el-icon-setting',
    HasQuickButton: false,
    Comments: '',
    NewUserId: 0,
    NewDate: new Date(),
    
    ParentName: '',
    NewUserName: '',

    OptionId: 0,
    ViewPermission: true,
    AddPermission: false,
    DelPermission: false,
    EditPermission: false,
    ApprovePermission: false,
    DeclinePermission: false,
}
export interface PrivilegeData {
    [key: string]: any
    ItemId: number
    ItemCode: string
    ParentId: number
    ItemName: string
    ItemUrl: string
    SeqId: number
    IsMenu: boolean
    Icon: string
    HasQuickButton: boolean
    Comments: string
    NewUserId: number
    NewDate: Date
    
    ParentName: string
    NewUserName: string

    OptionId: number
    AddPermission: boolean
    DelPermission: boolean
    EditPermission: boolean
    ApprovePermission: boolean
    ViewPermission: boolean
    DeclinePermission: boolean
}

export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getData = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}

export const getParentList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetParentList,
        params: { type: firstType }
    })
}

export const getCategoryList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetCategoryList,
        params: { type: firstType }
    })
}
